import { ApplicationAgent } from "../../Utilities/Platform/Applications/ApplicationAgent";
import { Bootstrapper } from "../Bootstrapper";

export class ApplicationAgentBootstrapper extends Bootstrapper {
    /**
     * @inheritDoc
     */
    public bootstrap(): MaybePromise<void> {
        // Needs to be initialised like this to avoid an infinite loop
        if(typeof window !== "undefined") {
            (window as unknown as { __shopfront: Record<string, unknown>; }).__shopfront = {
                ApplicationAgent: ApplicationAgent,
            };
        }
    }
}
